import type {MyUser, User} from '@deezer/next/contexts/main/types';

export type LanguageOption = {
	label: string;
	value: string;
};

export enum MODAL_STATE {
	EDIT_PASSWORD = 'edit_password',
	EDIT_EMAIL = 'edit_email',
	DELETE_CONNECTED_ACCOUNTS = 'delete_connected_accounts',
	DELETE_ACCOUNT = 'delete_account',
}

export type UserForm = (MyUser | User) & {
	password?: string;
	confirmationPassword?: string;
	currentPassword?: string;
};
